<template>
	<blockquote v-html="block.quote"></blockquote>
</template>

<script>

	export default {
		props: ['block']
	}

</script>

<style lang="scss" scoped>

	@import "media";

	blockquote {
		font-size:2.5rem; line-height:1.25; font-family:'oswald'; color:#FDB913; position:relative; text-transform:uppercase; margin-left:1.6rem;
		@include media(large) {
			font-size:4rem; margin-left:2.5vw; margin-right:2.5vw;
			&.first {
				margin-top:2.5vw;
			}
		}
		&:before {
			content:'“'; position:absolute; left:-.8rem; top:0; transform:translateX(-50%); font-size:inherit;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/BlogBlockTypes/Quote.vue